import axios from '../../plugins/axios'

export const getPickupGoogleSheetsConfig = (_, { params = {} } = {}) => {
  return axios.get('/settings/pickup-google-sheets', { params })
}

export const updatePickupGoogleSheetsConfig = (_, { data }) => {
  return axios.put('/settings/pickup-google-sheets', data)
}

export const testPickupGoogleSheetsConnection = (_, { data } = {}) => {
  return axios.post('/settings/pickup-google-sheets/test', data)
}

export const syncPickupGoogleSheets = (_, { data } = {}) => {
  return axios.post('/settings/pickup-google-sheets/sync', data)
}
